import * as yup from 'yup';
import { nullableImageFromCMSSchema } from '../../cms';

const giftVariantProductCardSchema = yup
  .object({
    name: yup.string().required(),
    value: yup.string().required(),
    image: nullableImageFromCMSSchema,
    minWeight: yup
      .number()
      .nullable()
      .transform(v => (isNaN(v) ? null : v)),
    maxWeight: yup
      .number()
      .nullable()
      .transform(v => (isNaN(v) ? null : v)),
    level: yup.string(),
    description: yup.string(),
    hidden: yup.boolean().default(false),
    disabled: yup.boolean().default(false),
    pillText: yup.string(),
    pillVariant: yup.string(),
    discountCodes: yup.array(yup.string()),
  })
  .transform(value => ({
    name: value.display_name,
    value: value.value,
    image: value.image,
    minWeight: value.minWeight,
    maxWeight: value.maxWeight,
    level: value.level || undefined,
    description: value.description,
    hidden: value.hidden,
    disabled: value.disabled,
    pillText: value.pillText,
    pillVariant: value.pillVariant || undefined,
    discountCodes: (value.discountCodes || '')
      .split(',')
      .map(code => code.trim())
      .filter(Boolean),
  }));

export const giftTypeSchema = yup
  .object({
    name: yup.string().required(),
    choices: yup.array(giftVariantProductCardSchema).required(),
    defaultChoice: yup.array(giftVariantProductCardSchema).required(),
    hasWeightRecommendations: yup.boolean(),
  })
  .transform(value => ({
    name: value.name,
    choices: value.choices?.filter(item => !item.hidden) || undefined,
    defaultChoice:
      value.defaultChoice?.filter(item => !item.hidden) || undefined,
    hasWeightRecommendations: value.hasWeightRecommendations ?? undefined,
  }));
